import { Action, getModule, Module, Mutation } from "vuex-module-decorators"
import store from "@/store"
import VuexModuleSearch from "@/store/VuexModuleSearch"
import { FaoCountry } from "@/model/interfaces/fao/faoCountry"
import FaoCountryService from "@/services/fao/FaoCountryService"

@Module({ dynamic: true, store, name: "FaoCountryModule", namespaced: true })
class FaoCountryModule extends VuexModuleSearch {
  faoCountries: FaoCountry[] = []
  dialogForm = false
  faoCountry: FaoCountry = {}

  @Mutation
  setFaoCountries(faoCountries: FaoCountry[]): void {
    this.faoCountries = faoCountries
  }

  @Mutation
  setDialogForm(dialogForm: boolean): void {
    this.dialogForm = dialogForm
  }

  @Mutation
  setCurrent(faoCountry: FaoCountry): void {
    this.faoCountry = faoCountry
  }

  @Action
  async getAll(): Promise<void> {
    getModule(FaoCountryModule).setLoading(true)
    const results = await FaoCountryService.get(this.pagination).finally(() => {
      getModule(FaoCountryModule).setLoading(false)
    })

    getModule(FaoCountryModule).mergePagination(results.pagination)

    this.setFaoCountries(results.faoCountries)
  }

  @Action({ rawError: true })
  async saveCurrent() {
    getModule(FaoCountryModule).setLoading(true)
    try {
      getModule(FaoCountryModule).setCurrent(await FaoCountryService.patch(this.faoCountry))
      const index = getModule(FaoCountryModule).faoCountries.findIndex(item => item.id === this.faoCountry.id)
      if (index !== -1) {
        getModule(FaoCountryModule).faoCountries.splice(index, 1, this.faoCountry)
      }
    } finally {
      getModule(FaoCountryModule).setLoading(false)
    }
  }
}

export default getModule(FaoCountryModule)
